<template>
    <tr>
        <td class="col-xs-1">
            <a href="#" class="department-handle"><i class="fa fa-sort"></i></a>
        </td>
        <td class="text-center">
            <router-link
                class="btn btn-sm"
                style="width:80%"
                :class="{ active: isActive }"
                :to="{ name: 'department', params: { departmentSlug: department.slug } }"
                :id="department.slug">
                {{ department.name }}
            </router-link>
        </td>
        <td>
            <router-link
                :to="{ name: 'edit-department', params: { departmentSlug: department.slug } }"
            >
                <i class="fa fa-edit"></i>
            </router-link>
            <a
                href="#"
                @click.prevent="confirmDelete"
            >
                <i class="fa fa-trash-o"></i>
            </a>
        </td>
    </tr>
</template>

<script>
import { removeDepartment } from "../../../api/departments/departments";

export default {
        name: 'department-menu-item',

        data() {
            return {}
        },

        props: {
            department: {
                type: Object,
                required: true,
            }
        },

        computed: {
            departmentSlug() {
                return this.department.slug;
            },

            isActive() {
                return (this.$route.params.departmentSlug === this.departmentSlug);
            },
        },

        methods: {
            confirmDelete() {
                this.$snotify.confirm(
                    `Are you sure you want to remove ${this.department.name}?`,
                    {
                        timeout: 5000,
                        showProgressBar: true,
                        closeOnClick: false,
                        pauseOnHover: true,
                        position: 'centerCenter',
                        buttons: [
                            {
                                text: 'Yes',
                                action: this.deleteDepartment
                            },
                            {
                                text: 'No',
                                action: ( toast ) => {
                                    this.$snotify.remove( toast.id );
                                }
                            }
                        ]
                    }
                )
            },

             async deleteDepartment(toast) {
                 try {
                     let slug = this.department.slug;
                     await removeDepartment(this.department.slug);
                     let departments = _.filter(
                         this.$store.getters.departments,
                         function ( department ) {
                             return department.slug !== slug;
                         }
                     );
                     this.$store.commit( 'departments', departments );
                     if (this.$route.name !== 'home') {
                         await this.$router.push( { name: 'home' } );
                     }
                     this.$snotify.success(`${this.department.name} removed`);
                } catch ( e ) {
                 console.error(e);
                 this.$snotify.error('Problem removing department');
                }

                this.$snotify.remove(toast.id);
             }
        }
    }
</script>